import { all } from 'redux-saga/effects';
import { wrapperSagas } from 'guardian/comp/wrapper/wrapperReducer';
import { accountsSagas } from 'guardian/comp/accounts/accountsReducer';
import { scansSagas } from 'guardian/comp/scans/scansReducer';
import { dashboardSagas } from 'guardian/comp/dashboard/dashboardReducer';
import { authSagas } from 'guardian/comp/login/authReducer';
import { apiKeysSagas } from 'guardian/comp/apiKeys/apiKeysReducer';
import { membersSagas } from 'guardian/comp/settings/membersReducer';

export default function* guardianSagas() {
  yield all([
    authSagas(),
    wrapperSagas(),
    accountsSagas(),
    scansSagas(),
    dashboardSagas(),
    apiKeysSagas(),
    membersSagas(),
  ]);
}
